import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  Equipment,
  GetParams,
  GetAdvancedParams,
  GetResponse,
  KeyValueGroup,
  Location,
  Partner,
  Service,
  ServiceOrder,
  ServiceOrderIncludeOption,
  TableColumn,
  ToastConfig,
} from '@app/shared';
import { Router } from '@angular/router';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { combineLatest, forkJoin, take } from 'rxjs';
import { finalize } from 'rxjs';
import { AsignEquipmentDrawerComponent } from '../../drawers/asign-equipment-drawer/asign-equipment-drawer.component';
import { ProjectUtilsService } from '../../services/project-utils.service';
import {
  EquipmentService,
  FlowEventService,
  ScreenService,
  StServiceService,
  getSafeImageUrl,
} from '@app/core';
import { GlobalValuesService } from '../../../../core/services/global-values.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../../core/services/auth.service';
import { ServiceOrderDetailsDrawerComponent } from '../../../maestros/drawers/service-order-details-drawer/service-order-details-drawer.component';
import { OrdersDetailsActivitiesDrawerComponent } from '../../shared/drawers/orders-details-activities-drawer/orders-details-activities-drawer.component';
import { CreateServiceDrawerComponent } from '../../drawers/create-service-drawer/create-service-drawer.component';
import { ServiceOrderRefreshService } from 'src/app/features/opportunities/services/project-utils.service';

@Component({
  selector: 'app-service-detail-main',
  standalone: false,

  templateUrl: './service-detail-main.component.html',
  styleUrl: './service-detail-main.component.less',
})
export class ServiceDetailMainComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() padding: boolean = true;
  @Input() overflowAuto: boolean = true;
  @Input() isDrawer: boolean = true;
  @Output() isDocDrawerOpen: EventEmitter<boolean> = new EventEmitter<boolean>(
    false
  );
  @Output() creationCompleted: EventEmitter<void> = new EventEmitter<void>();
  @Output() deletionCompleted: EventEmitter<void> = new EventEmitter<void>();
  // Obtener los templates de cada tab
  @ViewChild('equipmentTmpl', { static: true }) teamsTmpl!: TemplateRef<any>;
  @ViewChild('docsTmpl', { static: true }) docsTmpl!: TemplateRef<any>;
  @ViewChild('ordersTmpl', { static: true }) ordersTmpl!: TemplateRef<any>;
  @ViewChild('inboxTmpl', { static: true }) inboxTmpl!: TemplateRef<any>;
  @ViewChild('tariffTmpl', { static: true }) tariffTmpl!: TemplateRef<any>;
  @ViewChild('detailTmpl', { static: true }) detailTmpl!: TemplateRef<any>;
  @ViewChild('flowTmpl', { static: true }) flowTmpl!: TemplateRef<any>;
  @ViewChild('notificationTmpl') notificationTmpl: any;

  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Operación exitosa.',
    showUndo: false,
  };

  notRef: any;

  tabs: { name: string; icon: string; tmpl: TemplateRef<any> }[] = [];
  afterViewInit: boolean = false;
  routesList: Location[] = [];
  isMobile$;
  loadingEquipments: boolean = true;
  partnerOptions: Partner[] = [];
  partnerlist: Partner[] = [];
  mojitoEmployeeList: Partner[] = [];
  cecEmployeeList: Partner[] = [];
  clientsList: Partner[] = [];
  driversList: Partner[] = [];
  forwarderList: Partner[] = [];
  providerList: Partner[] = [];
  currentEquipments: Equipment[] = [];

  drawRef: any;
  asignEquimentDetailDrawer: any;
  createServiceDrawer: any;

  // ServiceOrders properties
  serviceOrders: ServiceOrder[] = [];
  serviceOrderDetailsDrawerComponent = OrdersDetailsActivitiesDrawerComponent;
  private readonly tableServiceOrderIncludes: ServiceOrderIncludeOption[] = [
    'Events',
    'AssignedTo',
    'AssignedToPartner',
    'CostCenter',
  ];

  // Forzar el uso de OrdersDetailsActivitiesDrawerComponent
  get ordersDetailsComponent() {
    return OrdersDetailsActivitiesDrawerComponent;
  }

  // Columnas para la tabla (mostrar datos)
  serviceOrderColumnsData: TableColumn[] = [
    {
      name: 'ID',
      pathData: { name: 'id', type: 'number' },
      noVisibleInTable: true,
    },
    {
      name: '',
      checkbox: true,
      align: 'center',
    },
    {
      name: 'Nombre de la subtarea',
      pathData: { name: 'subtaskName', type: 'text' },
      width: '250px',
    },
    {
      name: 'Estado',
      pathData: { name: 'formattedState', type: 'text' },
      width: '150px',
      readonly: true,
    },
    {
      name: 'Asignada a',
      pathData: {
        name: 'assignedTo',
        nestedPath: 'partner.name',
        type: 'text',
      },
      width: '120px',
      readonly: true,
    },
    {
      name: 'Fecha de inicio',
      pathData: { name: 'startDate', type: 'date' },
      width: '150px',
      readonly: true,
    },
    {
      name: 'Fecha de fin',
      pathData: { name: 'endDate', type: 'date' },
      width: '150px',
      readonly: true,
    },
  ];

  // Columnas para el formulario de creación/edición (campos editables)
  get serviceOrderFormColumnsData(): TableColumn[] {
    return [
      {
        name: 'Nombre de la subtarea',
        pathData: { name: 'subtaskName', type: 'text' },
        width: '250px',
        validators: [
          {
            error: 'required',
            message: 'El nombre de la subtarea es requerido',
            function: (control: any) => (control.value && control.value.toString().trim() !== '') ? null : { required: true },
          },
        ],
      },
      {
        name: 'Estado',
        pathData: { name: 'state', type: 'select' },
        width: '150px',
        optionList: this._flowsOptions, // Flows cargados dinámicamente
        validators: [
          {
            error: 'required',
            message: 'El estado es requerido',
            function: (control: any) => (control.value !== null && control.value !== undefined && control.value !== '') ? null : { required: true },
          },
        ],
      },
      {
        name: 'Asignada a',
        pathData: {
          name: 'assignedToId',
          type: 'select',
        },
        width: '120px',
        optionList: this._commercialsOptions, // Comerciales cargados dinámicamente
        validators: [
          {
            error: 'required',
            message: 'El campo Asignada a es requerido',
            function: (control: any) => (control.value !== null && control.value !== undefined && control.value !== '') ? null : { required: true },
          },
        ],
      },
      {
        name: 'Centro de costo',
        pathData: { name: 'costCenterId', type: 'select' },
        width: '150px',
        optionList: this._costCenterOptions, // Centros de costo cargados dinámicamente
        validators: [
          {
            error: 'required',
            message: 'El Centro de costo es requerido',
            function: (control: any) => (control.value !== null && control.value !== undefined && control.value !== '') ? null : { required: true },
          },
        ],
      },
      {
        name: 'Prioridad',
        pathData: { name: 'priority', type: 'select' },
        width: '100px',
        optionList: [
          { id: 'Low', name: 'Baja', label: 'Baja' },
          { id: 'Medium', name: 'Media', label: 'Media' },
          { id: 'High', name: 'Alta', label: 'Alta' },
          { id: 'VeryHigh', name: 'Muy Alta', label: 'Muy Alta' },
        ],
        validators: [
          {
            error: 'required',
            message: 'La Prioridad es requerida',
            function: (control: any) => (control.value !== null && control.value !== undefined && control.value !== '') ? null : { required: true },
          },
        ],
      },
      {
        name: 'Fecha de inicio',
        pathData: { name: 'startDate', type: 'date' },
        width: '150px',
      },
      {
        name: 'Fecha de fin',
        pathData: { name: 'endDate', type: 'date' },
        width: '150px',
      },
      {
        name: 'Cierre previsto',
        pathData: { name: 'expectedClosure', type: 'date' },
        width: '150px',
      },
    ];
  }

  protected readonly getSafeImageUrl = getSafeImageUrl;

  constructor(
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private drawerService: NzDrawerService,
    private modalService: NzModalService,
    private notificationService: NzNotificationService,
    private ps: ProjectUtilsService,
    private screenService: ScreenService,
    private equipmentService: EquipmentService,
    private stServiceService: StServiceService,
    private flowEventService: FlowEventService,
    public authService: AuthService,
    public globalValuesService: GlobalValuesService,
    private serviceOrderRefreshService: ServiceOrderRefreshService,
    private destroyRef: DestroyRef
  ) {
    this.globalValuesService.places$
      .pipe(takeUntilDestroyed())
      .subscribe((value) => (this.routesList = value));
    this.globalValuesService.isPartnerReady$
      .pipe(takeUntilDestroyed())
      .subscribe((value) => {
        if (value) {
          this.partnerlist = this.globalValuesService.partnerlist;
          this.forwarderList = this.globalValuesService.forwarderList;
          this.providerList = this.globalValuesService.providerList;
          this.clientsList = this.globalValuesService.clientsList;
        }
      });

    this.isMobile$ = screenService.isMobile$;
  }

  @Input() _service!: Service;

  get service(): Service {
    return this._service;
  }

  private serviceInitialized: boolean = false;

  @Input()
  set service(value: Service) {
    this._service = value;
    // Si el servicio se establece y el componente ya se inicializó, cargar los datos
    if (value && this.serviceInitialized) {
      this.getNonPartnerData(); // Esto cargará el flow y luego las subtareas
      this.getEquipmentInService();
      this.loadFormOptions(); // Cargar opciones del formulario con serviceId
    }
  }

  ngOnInit() {
    this.serviceInitialized = true;
    if (this.service) {
      this.getNonPartnerData(); // Esto cargará el flow y luego las subtareas
      this.getEquipmentInService();
    }
    this.serviceOrderRefreshService.refreshTable$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadServiceOrders();
      });

    // Cargar options para los campos del formulario
    this.loadFormOptions();

    // Suscribirse al evento de cerrar todos los drawers
    this.ps.closeAllDrawers$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((shouldClose) => {
        if (shouldClose) {
          // Los drawers se cierran desde el layout-maestro, no necesitamos hacer nada aquí
          console.log('Close all drawers event received');
        }
      });
  }

  ngAfterViewInit(): void {
    this.tabs = [
      // {name: 'Inbox', icon: 'inbox', tmpl: this.inboxTmpl},
      // {name: 'Detalles', icon: 'info', tmpl: this.detailTmpl},
      {
        name: 'Subtareas',
        icon: 'checklist',
        tmpl: this.ordersTmpl,
      },
      { name: 'Flujo', icon: 'linear_scale', tmpl: this.flowTmpl },
      { name: 'Documentos', icon: 'description', tmpl: this.docsTmpl },
      /*   { name: 'Equipos', icon: 'warehouse', tmpl: this.teamsTmpl }, */
      // {name: 'Tarifas', icon: 'currency_exchange', tmpl: this.tariffTmpl},
    ];

    this.afterViewInit = true;
    this.cdRef.detectChanges();
  }

  openAsignEquipmentDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        this.asignEquimentDetailDrawer = this.drawerService.create({
          nzClosable: false,
          nzMask: true,
          nzWidth: 952,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzContent: AsignEquipmentDrawerComponent,
        });

        this.asignEquimentDetailDrawer.afterClose.subscribe(() => {
          this.currentEquipments = [
            ...(this.ps.selectedService!.equipments || []),
          ];
          this.cdRef.detectChanges();
        });
      });
  }

  onEquipmentsChanged(equipments: Equipment[]): void {
    this.currentEquipments = [...equipments];
    this.cdRef.detectChanges();
  }

  setDetailKaeyValueItems(): KeyValueGroup[] {
    return [
      {
        name: 'Agentes',
        layout: 'collapse',
        dissabled: true,
        items: [
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.providerList,
            label: 'Proveedor',
            type: 'avatar',
            editable: true,
            path: 'supplierId',
            value: {
              userId: this.service!.supplierId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.forwarderList,
            label: 'Agente de transporte',
            type: 'avatar',
            editable: true,
            path: 'forwarderId',
            value: {
              userId: this.service!.forwarderId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.clientsList,
            label: 'Expedidor',
            type: 'avatar',
            editable: true,
            path: 'shipperId',
            value: {
              userId: this.service!.shipperId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.clientsList,
            label: 'Destinatario',
            type: 'avatar',
            editable: true,
            path: 'consigneeId',
            value: {
              userId: this.service!.consigneeId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.partnerOptions,
            label: 'Contacto origen',
            type: 'avatar',
            editable: true,
            path: 'originContactId',
            value: {
              userId: this.service!.originContactId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.partnerOptions,
            label: 'Contacto destino',
            type: 'avatar',
            editable: true,
            path: 'destinationContactId',
            value: {
              userId: this.service!.destinationContactId,
            },
          },
        ],
      },
      {
        name: 'Ruta',
        layout: 'collapse',
        dissabled: true,
        items: [
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            label: 'Fechas',
            type: 'date',
            editable: true,
            path: 'startDatePlan',
            value: {
              startDate: this.service!.startDatePlan,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            label: 'Tipo Transporte',
            editable: true,
            noWrap: true,
            required: false,
            type: 'select',
            path: 'typeId',
            list: this.globalValuesService.transportTypes$.value,
            selectLabel: 'name',
            selectValue: 'id',
            value: this.service!.transportTypeId,
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.routesList,
            label: 'Origen',
            type: 'route',
            editable: true,
            path: 'originId',
            value: {
              origin: this.service!.originId,
            },
          },
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            list: this.routesList,
            label: 'Destino',
            type: 'route',
            editable: true,
            path: 'destinationId',
            value: {
              origin: this.service!.destinationId,
            },
          },
        ],
      },
      {
        name: 'Especificaciones',
        layout: 'collapse',
        dissabled: true,
        items: [
          {
            parentObject: this.service,
            component: 'ServiceDetailMainComponent',
            label: 'Especificaciones técnicas de la mercancía',
            editable: true,
            noWrap: true,
            required: false,
            type: 'text',
            path: 'technicalSpecifications',
            value: this.service!.technicalSpecifications,
          },
        ],
      },
    ];
  }

  getNonPartnerData(): void {
    const serviceBasicGetParams: GetParams = {
      startRow: 0,
      endRow: 100,
      sortDirection: 'asc',
      sortProperty: 'id',
      filterProperty: 'serviceId',
      filterValue: this.service.id.toString(),
    };

    this.flowEventService
      .getFlow(serviceBasicGetParams)
      .subscribe((rsp: GetResponse) => {
        this.service.flow =
          rsp.data.rows?.length > 0 ? rsp.data.rows[0] : undefined;
        // Cargar las subtareas después de que el flow esté disponible
        this.loadServiceOrders();
      });
  }

  sendIsDocDrawerOpen(value: boolean) {
    this.isDocDrawerOpen.emit(value);
  }

  getEquipmentInService() {
    if (this.service.equipments && this.service.equipments.length > 0) {
      const requests: any = this.service.equipments.map((e) =>
        this.equipmentService.getEquipment({
          startRow: 0,
          endRow: 1,
          sortDirection: 'asc',
          sortProperty: 'id',
          filterProperty: 'id',
          filterValue: e.id.toString(),
        })
      );

      forkJoin(requests).subscribe({
        next: (rsp: any) => {
          this.service.equipments = rsp.map(
            (r: GetResponse) => r?.data?.rows[0]
          );
          this.currentEquipments = [...(this.service.equipments || [])];
          this.cdRef.detectChanges();
          this.loadingEquipments = false;
        },
        error: (e) => {
          console.error(e);
          this.loadingEquipments = false;
        },
      });
    } else {
      this.loadingEquipments = false;
      console.log('Muestra la tabla antes de la peticion');
    }
  }

  ngOnDestroy() {
    this.drawRef?.close();
    this.asignEquimentDetailDrawer?.close();
  }

  closeAllDrawers() {
    this.ps.closeAllDrawers$.next(true);
    setTimeout(() => {
      this.ps.closeAllDrawers$.next(false);
    }, 100);
  }

  onCreationCompleted(): void {
    // Después de crear una subtarea exitosamente, cerrar todos los drawers y navegar
    this.closeAllDrawers();
    this.navigateToServiceOrders();
  }

  onDeletionCompleted(): void {
    // Después de eliminar una subtarea exitosamente, cerrar todos los drawers y navegar
    this.closeAllDrawers();
    this.navigateToServiceOrders();
  }

  loadFormOptions(): void {
    // Cargar flows para el campo Estado filtrados por serviceId
    const serviceId = this.service?.id;
    console.log('DEBUG loadFormOptions - service:', this.service);
    console.log('DEBUG loadFormOptions - serviceId:', serviceId);

    this.flowEventService
      .getFlow({
        startRow: 0,
        endRow: 100,
        sortDirection: 'asc',
        sortProperty: 'id',
        // Filtrar por serviceId si existe
        ...(serviceId && {
          filterProperty: 'serviceId',
          filterValue: serviceId.toString(),
        }),
      })
      .subscribe({
        next: (response) => {
          if (response.data?.rows && response.statusCode === 200) {
            // En lugar de mostrar flows, mostrar los events de esos flows
            const events: any[] = [];
            response.data.rows.forEach((flow: any) => {
              if (flow.events) {
                flow.events.forEach((event: any) => {
                  events.push({
                    id: event.id, // Usar event.id como id
                    name: event.name, // Mostrar nombre del event
                    label: `${event.name} (${flow.name})`, // Nombre + flow de referencia
                  });
                });
              }
            });

            // Asignar events a la propiedad para que esté disponible en el getter
            this._flowsOptions = events;
          }
        },
        error: (error) => {
          console.error('Error loading flows for Estado field:', error);
        },
      });

    // Cargar comerciales para el campo Asignada a
    this.globalValuesService.users$.subscribe((users) => {
      if (users && users.length > 0) {
        // Filtrar usuarios que sean comerciales (roleId podría ser 1 para comerciales)
        // O usar todos los usuarios con partners
        const comerciales = users
          .filter((user) => user.partner && user.partner.name)
          .map((user) => ({
            id: user.id, // ✅ Usar userId en lugar de partnerId
            name: user.partner.name,
            label: user.partner.name,
          }));

        // Asignar comerciales a la propiedad estática para que esté disponible en el getter
        this._commercialsOptions = comerciales;
      }
    });

    // Cargar centros de costo para el campo Centro de costo
    this.globalValuesService.costCenters$.subscribe((costCenters) => {
      if (costCenters && costCenters.length > 0) {
        const costCenterOptions = costCenters.map((costCenter) => ({
          id: costCenter.id,
          name: costCenter.name,
          label: costCenter.name,
        }));

        // Asignar centros de costo a la propiedad estática para que esté disponible en el getter
        this._costCenterOptions = costCenterOptions;
      }
    });
  }

  // Propiedades privadas para almacenar las opciones cargadas
  private _flowsOptions: any[] = [];
  private _commercialsOptions: any[] = [];
  private _costCenterOptions: any[] = [];

  navigateToServiceOrders(): void {
    // Solo recargar los datos, los drawers ya se cerraron
    // No navegar para evitar loops infinitos
    console.log('Datos recargados después de operación');
  }

  getTransportTypeName(transportTypeId?: number): string {
    if (!transportTypeId) return '-';
    const transportTypes = this.globalValuesService.transportTypes$.value || [];
    const transportType = transportTypes.find(
      (t: any) => t.id === transportTypeId
    );
    return transportType?.name || '-';
  }

  loadServiceOrders(): void {
    if (!this.service?.id) return;

    const params: GetAdvancedParams = {
      startRow: 0,
      endRow: 5000,
      sortProperty: 'id',
      sortDirection: 'asc',
      includes: this.tableServiceOrderIncludes,
      filterGroups: [
        [
          {
            property: 'serviceId',
            value: this.service.id,
            operator: 'Equals',
          },
        ],
      ],
    };

    this.stServiceService.getAdvancedServiceOrder(params).subscribe({
      next: (rsp: GetResponse) => {
        this.serviceOrders = (rsp.data?.rows || []).map(
          (order: ServiceOrder) => ({
            ...order,
            formattedState: this.formatServiceOrderState(order),
          })
        );
        this.cdRef.detectChanges();
      },
      error: (e: any) => {
        console.error('Error loading ServiceOrders', e);
      },
    });
  }

  createServiceOrder(event: any): void {
    // Si es un evento del botón "Añadir" (string), abrir el drawer
    if (typeof event === 'string') {
      this.openCreateServiceDrawer();
      return;
    }

    // Si es un payload de creación, crear la subtarea
    if (!this.service?.id) return;

    // Obtener el estado inicial (primer evento del flujo)
    const initialEventTypeId = this.getInitialEventTypeId();

    const payloadToSend = {
      ...event,
      serviceId: this.service.id,
      state: initialEventTypeId.toString(), // Asignar estado inicial
      createdAt: event.createdAt || new Date().toISOString(),
    };

    this.stServiceService
      .createServiceOrder(payloadToSend)
      .pipe(finalize(() => {}))
      .subscribe({
        next: (rsp: any) => {
          // Mostrar notificación de éxito
          this.showNotification('Subtarea creada exitosamente.');
          // Recargar la lista completa desde el servidor para asegurar datos actualizados
          this.loadServiceOrders();
          // Cerrar drawers y navegar después de creación exitosa
          this.onCreationCompleted();
        },
        error: (e: any) => {
          console.error('Error creating ServiceOrder', e);
        },
      });
  }

  private formatServiceOrderState(order: ServiceOrder): any {
    if (!order.state) {
      return { name: '-', class: 'black', icon: '' };
    }

    // Usar los events del flow del servicio padre
    const flowEvents = this.service?.flow?.events || [];
    
    if (flowEvents.length === 0) {
      return { name: 'Sin flujo', class: 'subtle-grey', icon: '' };
    }
    
    // Comparar como números para evitar problemas de tipo
    const stateNum = typeof order.state === 'number' ? order.state : parseInt(order.state);
    const event = flowEvents.find((e: any) => e.id === stateNum);

    if (!event) {
      console.warn('⚠️ No se encontró evento para state:', order.state);
      return { name: 'Sin estado', class: 'subtle-grey', icon: '' };
    }

    // Mapear nombres antiguos a nuevos (para compatibilidad con BD)
    let eventName = event.name;
    if (eventName === 'Orden creada') eventName = 'Tarea creada';
    if (eventName === 'Orden finalizada') eventName = 'Tarea finalizada';

    // Aplicar colores especiales para eventos importantes
    let eventClass: string;
    switch (event.color) {
      case '#0072F5': // Por Hacer
        eventClass = 'subtle-blue';
        break;
      case '#0d6efd': // En Progreso (Bootstrap azul) - usar teal para diferenciarlo
        eventClass = 'subtle-teal';
        break;
      case '#A8A8A8':
        eventClass = 'subtle-grey';
        break;
      case '#8E4EC6':
      case '#6f42c1': // Revisión Interna (Bootstrap morado)
        eventClass = 'subtle-purple';
        break;
      case '#FF990A':
      case '#ffc107': // En Espera (Bootstrap amarillo)
        eventClass = 'subtle-amber';
        break;
      case '#E5484D':
      case '#dc3545': // Cancelada (Bootstrap rojo)
        eventClass = 'subtle-red';
        break;
      case '#EA3E83':
        eventClass = 'subtle-pink';
        break;
      case '#45A557':
      case '#198754': // Completada (Bootstrap verde)
        eventClass = 'subtle-green';
        break;
      case '#12A594':
        eventClass = 'subtle-teal';
        break;
      default:
        eventClass = 'black';
        break;
    }

    return {
      name: eventName,
      class: eventClass,
      icon: event.icon || '',
      color: event.color,
    };
  }

  openCreateServiceDrawer(): void {
    console.log('DEBUG openCreateServiceDrawer called');
    console.log('DEBUG service-detail-main - service:', this.service);
    console.log('DEBUG service-detail-main - serviceId:', this.service?.id);
    console.log(
      'DEBUG service-detail-main - service.flow:',
      this.service?.flow
    );
    // Abrir el drawer de crear servicio
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    })
      .pipe(take(1))
      .subscribe(({ isMobile, isMedium }) => {
        this.createServiceDrawer = this.drawerService.create({
          nzWidth: 793,
          nzHeight: '98%',
          nzPlacement: isMobile ? 'bottom' : 'right',
          nzClosable: false,
          nzMaskClosable: false,
          nzContent: CreateServiceDrawerComponent,
          nzData: {
            project: this.ps.selectedProject, // Pasar el proyecto seleccionado
            serviceId: this.service?.id, // Pasar el serviceId del servicio padre
          },
        });

        this.createServiceDrawer.afterClose.subscribe(() => {
          // Recargar la lista después de cerrar el drawer
          this.loadServiceOrders();
        });
      });
  }

  updateServiceOrder(payload: any): void {
    // Si es solo una recarga (sin ID), recargar la lista directamente
    if (payload.reload || payload.drawerClosed || payload.tableReloaded) {
      console.log(
        'Recargando service orders desde updateServiceOrder:',
        payload
      );
      this.loadServiceOrders();
      return;
    }

    if (!payload.id) return;

    this.stServiceService
      .updateServiceOrder(payload)
      .pipe(finalize(() => {}))
      .subscribe({
        next: (rsp: any) => {
          // Recargar la lista completa desde el servidor para asegurar datos actualizados
          this.loadServiceOrders();
        },
        error: (e: any) => {
          console.error('Error updating ServiceOrder', e);
        },
      });
  }

  deleteServiceOrder(id: number): void {
    if (!id) return;

    this.stServiceService
      .deleteServiceOrder([id])
      .pipe(finalize(() => {}))
      .subscribe({
        next: () => {
          // Mostrar notificación de éxito
          this.showNotification('Subtarea eliminada exitosamente');
          // Recargar la lista completa desde el servidor para asegurar datos actualizados
          this.loadServiceOrders();
          // Cerrar drawers y navegar después de eliminación exitosa
          this.onDeletionCompleted();
        },
        error: (e: any) => {
          console.error('Error deleting ServiceOrder', e);
        },
      });
  }

  deleteMultipleServiceOrders(ids: number[]): void {
    if (!ids || ids.length === 0) return;

    this.stServiceService
      .deleteServiceOrder(ids)
      .pipe(finalize(() => {}))
      .subscribe({
        next: () => {
          // Mostrar notificación de éxito
          this.showNotification(
            `${ids.length} subtarea(s) eliminada(s) exitosamente`
          );
          // Recargar la lista completa desde el servidor para asegurar datos actualizados
          this.loadServiceOrders();
          // Cerrar drawers y navegar después de eliminación exitosa
          this.onDeletionCompleted();
        },
        error: (e: any) => {
          console.error('Error deleting ServiceOrders', e);
        },
      });
  }

  private showNotification(message?: string): void {
    // Solo configurar toastConfig si se proporciona un mensaje o si no está configurado
    if (message || !this.toastConfig.content) {
      this.toastConfig = {
        icon: 'check_circle',
        iconColor: '#6CDA75',
        content: message || 'Operación exitosa.',
        showUndo: false,
      };
    }
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' }
    );
  }

  private getInitialEventTypeId(): number {
    return (
      (this.service?.flow?.events || []).find(
        (et) => et.name === 'Tarea creada'
      )?.id || 0
    );
  }
}
